/* eslint-disable */

import { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { addLabBillId, fetchLabBillId } from "./addLabEnteryService";
import { errorToast, successToast } from "../../../components/toastmessage/toastmessage";
import { handleLabEntryValidation } from "./addLabEnteryValidation";



const useAddLabRequestHook = (initialState) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [labEntryBillState, setLabEntryBillState] = useState([]);
    const [labEntry, setlabEntry] = useState(initialState);
    const [errors, setError] = useState({});
    const [entry, setEntry] = useState([]);



    const fetchLabEntryBillId = async () => {
        if (location?.state?.rowData?.billHeaderID) {
            try {
                let { data: { result }, status } = await fetchLabBillId(location?.state?.rowData?.billHeaderID);
                if (status === 200) {
                    setLabEntryBillState(result)
                }
            }
            catch (e) {
                errorToast("Failed To fetch Lab Entry")
            }
        }
        return;
    };


    const handleChange = (e, params,  type) => {
        const { name, value } = e.target;
        setlabEntry((prev) => ({
            ...prev,
            [params?.id]: {
                ...prev[params?.id],
                [name]: (type === "observedValue" ? Number(value) : value),
                componentID: params?.row?.componentID,
                billID: params?.row?.billHeaderID

            },
        }));
    };

    useEffect(() => {
        fetchLabEntryBillId()
    }, [location?.state?.rowData?.billHeaderID])

    function convertArrayOfObject(inputObject) {
        return Object.values(inputObject).map((entry) => ({
            observedValue: entry.observedValue,
            componentID: entry.componentID,
            billID: entry.billID,
            remarks: entry.remarks,
        }));

    }



    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            let finalObject = await convertArrayOfObject(labEntry)
            const { data, status } = await addLabBillId(finalObject);
            if (status === 200) successToast(data?.message ? data?.message : "Successfully Inserted");
            setlabEntry({})
        } catch (err) {
            errorToast(err?.response?.data?.message)
        }




    }
    const handleBlur = async () => {
        const newErrors = await handleLabEntryValidation(labEntry);
        setError(newErrors)

    };
    const handleGoBack = () => {
        navigate("/pathology/lab-entery")
    }
    const handleGetRowId = (e) => {
        console.log(e, "ee")
        e?.testID
    }

    return {
        errors,
        labEntryBillState,
        labEntry,
        handleChange,
        handleSubmit,
        handleBlur,
        handleGoBack,
        setlabEntry,
        handleGetRowId


    }


};


export default useAddLabRequestHook;


